export default __webpack_public_path__ + "static/media/bg-history-list_pc@2x.cbf73277.png";